import styled from 'styled-components';


export const Container = styled.div`
    background-color: #F4B7A2;
    width: 100%;
    padding: 20px;
    color: #3F2F2A;
`

export const Link = styled.div`
    padding: 20px;
    a {
        color: #3F2F2A;
        text-decoration: none;
    }
`

